<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-key', fontSet: 'fad'}"
	[headerText]="T.USER_CHANGE_PASSWORD | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<h2 class="mat-h2">
			@if (!enablePasswordChange) {
				{{ T.CHANGE_USER_PASSWORD_DIALOG_LOGGESN_IN_AS | translate }} {{ loggedInUser.username }}
			}

			@if (enablePasswordChange) {
				{{ T.CHANGE_USER_PASSWORD_DIALOG_SUCCESS_LOGGED_IN_AS | translate }} {{ loggedInUser.username }}
			}
		</h2>
		<h3 class="mat-h3">
			@if (!enablePasswordChange) {
				{{ T.USER_ADMIN_CONFIRM_IDENTITY | translate }}
			}

			@if (enablePasswordChange) {
				{{ T.CHANGE_USER_PASSWORD_DIALOG_SELECT_NEW_PASSWORD_FOR_THIS_USER | translate }}
			}
		</h3>

		@if (!enablePasswordChange) {
			<form>
				<mat-form-field class="full-width-form" color="accent">
					<mat-label>
						<mat-icon fontIcon="fa-key" fontSet="fad" inline />
						{{ T.CHANGE_USER_PASSWORD_DIALOG_PASSWORD_TO_VERIFY | translate }}
					</mat-label>
					<input
						(keyup.enter)="$event.preventDefault(); $event.stopPropagation(); verifyPasswordOfCurrentUser()"
						[formControl]="verifyPasswordFormControl"
						[type]="hidePasswordUnlock ? 'password' : 'text'"
						autocomplete="off"
						matInput
					/>
					<button
						(click)="hidePasswordUnlock = !hidePasswordUnlock"
						[attr.aria-label]="'Hide password'"
						[attr.aria-pressed]="hidePasswordUnlock"
						mat-icon-button
						matSuffix
						type="button"
					>
						@if (hidePasswordUnlock) {
							<mat-icon fontIcon="fa-eye-slash" fontSet="fas" inline style="font-size: 0.8em" />
						}
						@if (!hidePasswordUnlock) {
							<mat-icon fontIcon="fa-eye" fontSet="far" inline style="font-size: 0.8em" />
						}
					</button>
					@if (verifyPasswordFormControl.hasError("backendLoginError")) {
						<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_WRONG_PASSWORD | translate }} </mat-error>
					}
				</mat-form-field>
			</form>
		}

		@if (enablePasswordChange) {
			<form [@zoomInOnEnter] [formGroup]="newPasswordFormGroup">
				<mat-form-field class="full-width-form" color="accent" style="margin-bottom: 10px">
					<mat-label>
						<mat-icon fontIcon="fa-key" fontSet="fad" inline />
						{{ T.CHANGE_USER_PASSWORD_DIALOG_NEW_PASSWORD | translate }}
					</mat-label>
					<button
						(click)="hidePasswordNew = !hidePasswordNew"
						[attr.aria-label]="'Hide password'"
						[attr.aria-pressed]="hidePasswordNew"
						mat-icon-button
						matSuffix
					>
						@if (hidePasswordNew) {
							<mat-icon fontIcon="fa-eye-slash" fontSet="fas" inline style="font-size: 0.8em" />
						}
						@if (!hidePasswordNew) {
							<mat-icon fontIcon="fa-eye" fontSet="far" inline style="font-size: 0.8em" />
						}
					</button>
					<input [type]="hidePasswordNew ? 'password' : 'text'" autocomplete="off" formControlName="password" matInput />
					@if (newPasswordFormGroup.controls.password.hasError("invalidPwdLength")) {
						<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_LENGTH | translate }} </mat-error>
					}
					@if (newPasswordFormGroup.controls.password.hasError("required")) {
						<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_REQUIRED | translate }} </mat-error>
					}
					@if (newPasswordFormGroup.controls.password.hasError("noLowerCaseChar")) {
						<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_NO_LOWER_CASE | translate }} </mat-error>
					}
					@if (newPasswordFormGroup.controls.password.hasError("noUpperCaseChar")) {
						<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_NO_UPPER | translate }} </mat-error>
					}
					@if (newPasswordFormGroup.controls.password.hasError("noNumbers")) {
						<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_NO_NUMBERS | translate }} </mat-error>
					}
				</mat-form-field>
				<mat-form-field class="full-width-form" color="accent">
					<mat-label>
						<mat-icon fontIcon="fa-key" fontSet="fad" inline />
						{{ T.CHANGE_USER_PASSWORD_DIALOG_CONFIRM_NEW_PASSWORD | translate }}
					</mat-label>
					<button
						(click)="hidePasswordNew = !hidePasswordNew"
						[attr.aria-label]="'Hide password'"
						[attr.aria-pressed]="hidePasswordNew"
						mat-icon-button
						matSuffix
					>
						@if (hidePasswordNew) {
							<mat-icon fontIcon="fa-eye-slash" fontSet="fas" inline style="font-size: 0.8em" />
						}
						@if (!hidePasswordNew) {
							<mat-icon fontIcon="fa-eye" fontSet="far" inline style="font-size: 0.8em" />
						}
					</button>
					<input [type]="hidePasswordNew ? 'password' : 'text'" autocomplete="off" formControlName="confirmPassword" matInput />
					@if (newPasswordFormGroup.controls.confirmPassword.hasError("passwordMismatch")) {
						<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_PASSWORDS_DO_NOT_MATCH | translate }} </mat-error>
					}
				</mat-form-field>
			</form>
		}
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="enablePasswordChange ? updateUserPassword() : verifyPasswordOfCurrentUser()"
			[disabled]="
				enablePasswordChange
					? newPasswordFormGroup.invalid
					: verifyPasswordFormControl.invalid || verifyPasswordFormControl.pristine
			"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="enablePasswordChange ? T.UPDATE_PASSWORD_TXT : T.CHECK_IF_PASSWORD_IS_VALID"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
